import { ExtendedRouteConfig, RouteGroup } from '@/types/routing-types'


/**
 * Generate a route using the taskName as the primary key. The backend requires a `FormTechTaskView` to exist for the
 * corresponding tech task.
 */
export function generateTechTask(title: string, taskName: string, group: RouteGroup): ExtendedRouteConfig {
    return {
        name: title,
        path: `/${taskName}`,
        component: () => import('@/components/ui/DynamicTechTaskCard/index.vue'),
        meta: {
            title: title,
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: group
        },
        props: {
            title,
            taskName
        }
    }
}
